import { activityDay } from '../../../api/src/activity/activity-policy';

export interface VisitScope {
  sectionId: string;
  workspaceId?: string;
}
export function createActivityReporter(
  send: (scope: VisitScope) => Promise<{ nextAllowedAt: string }>,
) {
  const recent = new Map<string, number>();
  const pending = new Map<string, Promise<void>>();
  return (userId: string, scope: VisitScope): Promise<void> => {
    const key = JSON.stringify([activityDay(), userId, scope.workspaceId ?? '', scope.sectionId]);
    if ((recent.get(key) ?? 0) > Date.now()) return Promise.resolve();
    const inflight = pending.get(key);
    if (inflight) return inflight;
    const result = send(scope)
      .then(({ nextAllowedAt }) => {
        const until = Date.parse(nextAllowedAt);
        if (!Number.isFinite(until)) throw new Error('Некорректное подтверждение учёта активности');
        recent.delete(key);
        if (recent.size >= 1000) recent.delete(recent.keys().next().value!);
        recent.set(key, until);
      })
      .finally(() => pending.delete(key));
    pending.set(key, result);
    return result;
  };
}
